import { useContext, useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import { PaymentInfo, SubscriptionStatus } from "../lib/types";
import { generateSubscription } from "../lib/helpers/setupIntentConfirmation";
import { useLocation } from "react-router-dom";
import SubscriptionStatusContext from "../context/SubscriptionStatusContext";
import { urlMatchesSuccessfulPaymentIntent, urlMatchesSuccessfulSetupIntent } from "../lib/helpers/urlHelper";

const usePaymentInfo = (): PaymentInfo => {
  const { user, loading } = useAuth();
  const subscriptionStatus = useContext<SubscriptionStatus | null>(
    SubscriptionStatusContext
  );
  const location = useLocation();

  const [paymentInfo, setPaymentInfo] = useState<PaymentInfo>({});

  useEffect(() => {
    const checkSubscription = async () => {
      if (user === null || loading) {
        return;
      }

      if (subscriptionStatus == null) {
        return;
      }

      if (subscriptionStatus.subscription.basic.hasSubscription) {
        return;
      }

      const params = new URLSearchParams(location.search);

      if (
        urlMatchesSuccessfulPaymentIntent(params) ||
        urlMatchesSuccessfulSetupIntent(params)
      ) {
        return;
      }

      try {
        const result = await generateSubscription();
        if (result !== null) {
          setPaymentInfo(result);
        }
      } catch (error) {
        console.error("Error fetching subscription payment data:", error);
        setPaymentInfo({});
      }
    };

    void checkSubscription();
  }, [loading, user, subscriptionStatus, location.search]);

  return paymentInfo;
};

export default usePaymentInfo;
